// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TaskNotificationToasts-module__container___riGRp {
  position: fixed;
  right: 20px;
  bottom: 40px;
  z-index: 60;
  width: min(300px, 100vw - 24px);
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}

.TaskNotificationToasts-module__toast___Vf9X5 {
  pointer-events: auto;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 64px;
  padding: 16px 18px;
  border: 1px solid #e4e4e7;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.12);
  cursor: pointer;
  font-size: 14px;
  line-height: 1.25;
}

.TaskNotificationToasts-module__toastEntering___ru_Hq {
  animation: TaskNotificationToasts-module__slideUp___t6FbF 0.25s ease-out both;
}

.TaskNotificationToasts-module__toastLeaving___vJgkM {
  animation: TaskNotificationToasts-module__slideDown___D71CN 0.15s ease-in forwards;
}

.TaskNotificationToasts-module__toastCritical___RFD_9 {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.TaskNotificationToasts-module__toastAssignment___rSsk0 {
  background: #ffffff;
  color: #18181b;
  border-color: #e4e4e7;
}

.TaskNotificationToasts-module__toastEscalation___fqbzX {
  background: #fef2f2;
  color: #991b1b;
  border-color: #fecaca;
}

.TaskNotificationToasts-module__toastFollowedChange___RvIeo {
  background: #f0fdf4;
  color: #166534;
  border-color: #bbf7d0;
}

.TaskNotificationToasts-module__toastOverdue___bcoBF {
  background: #fefce8;
  color: #854d0e;
  border-color: #fde68a;
}

.TaskNotificationToasts-module__title___y0Tpw {
  flex: 1 1 auto;
  min-width: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.4;
}

.TaskNotificationToasts-module__closeButton___yJAgN {
  width: 18px;
  height: 18px;
  border: none;
  border-radius: 999px;
  background: transparent;
  color: #a1a1aa;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex: 0 0 auto;
  transition: color 0.15s ease;
}

.TaskNotificationToasts-module__closeButton___yJAgN:hover {
  color: #71717a;
}

.TaskNotificationToasts-module__closeIcon___d2PDr {
  width: 14px;
  height: 14px;
}

@keyframes TaskNotificationToasts-module__slideUp___t6FbF {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes TaskNotificationToasts-module__slideDown___D71CN {
  from {
    opacity: 1;
    transform: translateY(0);
  }
  to {
    opacity: 0;
    transform: translateY(8px);
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/TaskNotificationToasts/TaskNotificationToasts.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,oBAAA;AACF;;AAEA;EACE,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8CAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;AACF;;AAEA;EACE,6EAAA;AACF;;AAEA;EACE,kFAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,mBAAA;EACA,cAAA;EACA,qBAAA;AACF;;AAEA;EACE,cAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,oBAAA;EACA,uBAAA;EACA,cAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,cAAA;EACA,4BAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE;IACE,UAAA;IACA,2BAAA;EACF;EAEA;IACE,UAAA;IACA,wBAAA;EAAF;AACF;AAGA;EACE;IACE,UAAA;IACA,wBAAA;EADF;EAIA;IACE,UAAA;IACA,0BAAA;EAFF;AACF","sourcesContent":[".container {\n  position: fixed;\n  right: 20px;\n  bottom: 40px;\n  z-index: 60;\n  width: min(300px, calc(100vw - 24px));\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  pointer-events: none;\n}\n\n.toast {\n  pointer-events: auto;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  min-height: 64px;\n  padding: 16px 18px;\n  border: 1px solid #e4e4e7;\n  border-radius: 12px;\n  background: #ffffff;\n  box-shadow: 0 10px 24px rgba(24, 24, 27, 0.12);\n  cursor: pointer;\n  font-size: 14px;\n  line-height: 1.25;\n}\n\n.toastEntering {\n  animation: slideUp 0.25s ease-out both;\n}\n\n.toastLeaving {\n  animation: slideDown 0.15s ease-in forwards;\n}\n\n.toastCritical {\n  background: #fef2f2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.toastAssignment {\n  background: #ffffff;\n  color: #18181b;\n  border-color: #e4e4e7;\n}\n\n.toastEscalation {\n  background: #fef2f2;\n  color: #991b1b;\n  border-color: #fecaca;\n}\n\n.toastFollowedChange {\n  background: #f0fdf4;\n  color: #166534;\n  border-color: #bbf7d0;\n}\n\n.toastOverdue {\n  background: #fefce8;\n  color: #854d0e;\n  border-color: #fde68a;\n}\n\n.title {\n  flex: 1 1 auto;\n  min-width: 0;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n.closeButton {\n  width: 18px;\n  height: 18px;\n  border: none;\n  border-radius: 999px;\n  background: transparent;\n  color: #a1a1aa;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  flex: 0 0 auto;\n  transition: color 0.15s ease;\n}\n\n.closeButton:hover {\n  color: #71717a;\n}\n\n.closeIcon {\n  width: 14px;\n  height: 14px;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 1;\n    transform: translateY(0);\n  }\n\n  to {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TaskNotificationToasts-module__container___riGRp`,
	"toast": `TaskNotificationToasts-module__toast___Vf9X5`,
	"toastEntering": `TaskNotificationToasts-module__toastEntering___ru_Hq`,
	"slideUp": `TaskNotificationToasts-module__slideUp___t6FbF`,
	"toastLeaving": `TaskNotificationToasts-module__toastLeaving___vJgkM`,
	"slideDown": `TaskNotificationToasts-module__slideDown___D71CN`,
	"toastCritical": `TaskNotificationToasts-module__toastCritical___RFD_9`,
	"toastAssignment": `TaskNotificationToasts-module__toastAssignment___rSsk0`,
	"toastEscalation": `TaskNotificationToasts-module__toastEscalation___fqbzX`,
	"toastFollowedChange": `TaskNotificationToasts-module__toastFollowedChange___RvIeo`,
	"toastOverdue": `TaskNotificationToasts-module__toastOverdue___bcoBF`,
	"title": `TaskNotificationToasts-module__title___y0Tpw`,
	"closeButton": `TaskNotificationToasts-module__closeButton___yJAgN`,
	"closeIcon": `TaskNotificationToasts-module__closeIcon___d2PDr`
};
module.exports = ___CSS_LOADER_EXPORT___;
